import { isValidKzPhone } from "./phone";

const pad = (n: number) => String(n).padStart(2, "0");
const localDate = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const localTime = (d: Date) => `${pad(d.getHours())}:${pad(d.getMinutes())}`;
const HALF_HOUR_MS = 30 * 60 * 1000;

// Предлагаемое время возврата: сейчас + расчётное время × 1.5 (запас),
// вверх до ближайших :00/:30. Без расчётного времени - 20:00 сегодня или
// сейчас + 2 ч, если это позже. Пользователь всё равно видит и может поменять.
// Округление по эпохе совпадает с местными :00/:30, пока сдвиг пояса кратен
// получасу (Алматы - целые часы).
export const suggestReturn = (now: Date, durationMinutes: number | null | undefined) => {
  let target: number;
  if (durationMinutes != null && durationMinutes > 0) {
    target = now.getTime() + durationMinutes * 1.5 * 60 * 1000;
  } else {
    const evening = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 20, 0).getTime();
    target = Math.max(evening, now.getTime() + 2 * 60 * 60 * 1000);
  }
  const rounded = new Date(Math.ceil(target / HALF_HOUR_MS) * HALF_HOUR_MS);
  return { date: localDate(rounded), time: localTime(rounded) };
};

// Быстрый путь регистрации выхода: открыта с маршрута, не редактирование,
// оба сохранённых телефона валидны - сразу шаг подтверждения с
// предзаполненными датами. Иначе null - обычные шаги.
export const quickStart = (input: {
  hasPresetRoute: boolean;
  isEditing: boolean;
  contactPhone: string;
  emergencyPhone: string;
  durationMinutes?: number | null;
  now: Date;
}) => {
  if (!input.hasPresetRoute || input.isEditing) return null;
  if (!isValidKzPhone(input.contactPhone) || !isValidKzPhone(input.emergencyPhone)) return null;
  const ret = suggestReturn(input.now, input.durationMinutes);
  return { startDate: localDate(input.now), returnDate: ret.date, returnTime: ret.time };
};
